import React, { useState, useEffect } from "react";
import "./index.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import {
  getVehicleListAction,
  clearAllFleets,
} from "../../../../services/Store/Actions/manageVehicleAction";
import SvgImage from "../../../Icons/Icons";

import { sendAnalitics } from "../../../../services/Store/Actions/appActions";
import { useNavigate } from "react-router-dom";
import BankTxnInfo from "../BankTxnInfo";
import { getAllBank } from "../../../../services/Store/Actions/TripsAction";
import BankList from "../BankList";
// import BulkFastagAdd from "../BulkFastagAdd";
function FullBankList(props) {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const { setBankId, bankId,setAccNumber,
    accNumber } = props;
  const [show, setShow] = useState(false);
  const [btn, setBtn] = useState(false);
  // const [search, setSearch] = useState("");
  const [proceed, setProceed] = useState(0);
  const [fstOpen, setFstOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState(1);

  const [assignedStatus, setAsssignedStatus] = useState(3);
  const { allFleets, allFleetsList } = useSelector(
    (state) => state?.manageVehicle
  );
  const { advancedVehicleList, advancedVehicleListCount } = useSelector(
    (state) => state?.fleet
  );
  function toggleModal() {
    setOpen(!open);
    setProceed(0);
  }

  // const handleUserId = (val) => {
  //   handleUser(val);
  //   //onsole.log("useState change ho rha hai kya yahi ", val);
  // };

  const urlSearchParams = new URLSearchParams(window.location.search);

  const params = Object.fromEntries(urlSearchParams.entries());
  // console.log("url split", searchParam);

  let searchParam = params.search;

  console.log("url split", searchParam);

  const [search, setSearch] = useState(
    searchParam == undefined ? "" : searchParam
  );

  const offsetString =
    window.location.search === "" ? 0 : window.location.search.split("=")[2];
  const offsetVal = Number(offsetString);
  console.log("url split111", offsetString, offsetVal);
  const [offset, setOffset] = useState(offsetVal);

  const dispatch = useDispatch();
  const [rechargeRank, setRechargeRank] = useState(0);

  useEffect(() => {
    dispatch(getAllBank());
  }, []);
  //console.log("Data here is >>>>>>>>>",allFleetsList)
  //console.log(Data[0])
  function handleClick() {
    setBtn(!btn);
  }
  // const handleLoadMore = async () => {
  //     if (allFleetsList?.length < allFleets?.count)
  //     {
  //       setFetchMoreData(true);
  //       setOffset(offset + 10);
  //       dispatch(
  //         getVehicleListAction({
  //           offset: offset ,
  //           search: '',
  //           minKyc: '',
  //           sortAs: '',
  //           sortBy: '',
  //         })
  //       );

  //     }
  //     else
  //     {
  //       setFetchMoreData(false)
  //     }
  //   };
  //console.log("FleetID Testing",Data[0]?.fleetId)
  const handleClose = () => {
    setOpen(false);
    setProceed(0);
  };
  const handleShow = () => {
    dispatch(sendAnalitics("AddVeh_MV_FW_Web"));
    setOpen(true);
    //console.log("sdsdsdsdsdsdddddddddd");
  };

  //console.log("NEWMOON",Data[0].regNumber)

  const [openLink, setOpenLink] = useState(false);
  const [fleetId, setFleetId] = useState("");
  const [vehCat, setVehCat] = useState("1");
  const [regNumber, setRegNumber] = useState("");
  const [color, setColor] = useState(-1);
  const [bulkFastag, setBulkFastag] = useState(false);
  //const [autoRechargeState, setAutoRechargeState] = useState("On");

  // auto recharge home page

  // auto recharge select vehicles

  // auto recharge specific vehicle
  const [openRechargeOne, setOpenRechargeOne] = useState(false);
  const [rechargeFleetId, setRechargeFleetId] = useState("");
  const showRechargeOne = (fleetId) => {
    setRechargeFleetId(fleetId);
    setOpenRechargeOne(true);
  };

  const toggleRechargeOne = () => {
    setOpenRechargeOne(!openRechargeOne);
  };

  const closeRechargeOne = () => {
    setOpenRechargeOne(false);
  };

  const [vehNo, setVehNo] = useState("");
  const [limit, setLimit] = useState(0);
  const [showroomModal, setShowroomModal] = useState(false);
  const [showRequest, setshowRequest] = useState(false);
  const showroomModalFunc = () => {
    console.log("invoiceModal", showroomModal);
    setShowroomModal(!showroomModal);
  };

  const showRequests = () => {
    console.log("invoiceModal", showroomModal);
    setshowRequest(!showRequest);
  };
  const vehiclehistory = () => {
    navigate("/VehicleHistory", {
      state: {
        path: "all",
      },
    });
  };

  const { fastagWallet } = useSelector((state) => state?.fastag);
  console.log("-----------------", fastagWallet);
  const autoRechargeState = fastagWallet?.autoRecharge;
  const [openBankModal, setOpenBankModal] = useState(false);

  const closeBankModal = () => {
    setOpenBankModal(false);
    //setProceed(0);
    //console.log("closed");
  };

  function handleBankTOggle() {
    setOpenBankModal(!openBankModal);
    //setProceed(0);
  }

  const counting = advancedVehicleListCount;
  return (
    <div
      className="FullCustomerListBox"
      style={{ maxHeight: "100vh", minHeight: "100vh" }}
    >
      <div className="FullCustomerListTopBoxV2">
        <div
          className="FullCustomerListHeader fontNB20 col-6"
          style={{padding : "5px 0 0px 17px",fontSize : "28px"}}
        >
          bank
        </div>
      </div>
      <div
        className="FUllListSearchBar leftTopDiv"
        onClick={() => {
          setOpenBankModal(true);
        }}
        style={{ margin: "10px 12px 20px 11px", cursor: "pointer" }}
      >
        <div className="bulkSalarySvgHeading">
          <div
            style={{
              backgroundColor: "#FFF",
              padding: "4px",
              borderRadius: "4px",
              marginRight: "10px",
            }}
          >
            <SvgImage name="payBulkSalaryLogo" />
          </div>
          <div className="FontNS18">Add Statement</div>
        </div>
        <SvgImage name="rightArrow" />
      </div>
      <BankTxnInfo
        open={openBankModal}
        onHide={handleBankTOggle}
        // remarks={`Incentive Paid for Trip ${tripData?.tripNo}`}
        toggleModal={handleBankTOggle}
        handleClose={closeBankModal}
        userId={""}
      />{" "}
      <>
        <div className="customer-list" style={{ marginTop: "15px" }}>
          <BankList
            search={search}
            offset={offset}
            setOffset={setOffset}
            nextTrigger={props.nextTrigger}
            allowTrigger={props.allowTrigger}
            openLink={openLink}
            setOpenLink={setOpenLink}
            fleetId={fleetId}
            setFleetId={setFleetId}
            vehCat={vehCat}
            setVehCat={setVehCat}
            regNumber={regNumber}
            setRegNumber={setRegNumber}
            color={color}
            setColor={setColor}
            setVehRank={props.setVehRank}
            activeStatus={activeStatus}
            assignedStatus={assignedStatus}
            setBankId={setBankId}
            bankId={bankId}
            setAccNumber={setAccNumber}
            accNumber={accNumber}
          />
        </div>
      </>
    </div>
  );
}
export default FullBankList;
